
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

import { UserData } from './user-data';
import { HandleRequest } from './handleRequest';

declare var CONFIG:any;
@Injectable({
  providedIn: 'root'
})
export class ConferenceData {
  data: any;

  constructor(public http: HttpClient, public user: UserData, private handleRequest:HandleRequest) {}

  load(): any {
    if (this.data) {
      return of(this.data);
    } else {
      return this.http
        .get('assets/data/data.json')
        .pipe(map(this.processData, this));
    }
  }
  createRoom(){
    return this.http.get(CONFIG.API_ENDPOINT+"/api/create_room")
  }
  list(){
    return this.http.get(CONFIG.API_ENDPOINT+"/api/list_rooms")
  }
  endCall(call_id:string){
    return this.http.post(CONFIG.API_ENDPOINT+"/api/exit_room",{room_id:call_id, user_id: this.user.getUsername()})
  }
  processData(data: any) {
    // just some good 'ol JS fun with objects and arrays
    // build up the data by linking contacts to sessions
    this.data = data;

    // loop through each day in the schedule
    this.data.schedule.forEach((day: any) => {
      // loop through each timeline group in the day
      day.groups.forEach((group: any) => {
        // loop through each session in the timeline group
        group.sessions.forEach((session: any) => {
          session.contacts = [];
          if (session.contactNames) {
            session.contactNames.forEach((contactName: any) => {
              const contact = this.data.contacts.find(
                (s: any) => s.name === contactName
              );
              if (contact) {
                session.contacts.push(contact);
                contact.sessions = contact.sessions || [];
                contact.sessions.push(session);
              }
            });
          }
        });
      });
    });

    return this.data;
  }

  getTimeline(
    dayIndex: number,
    queryText = '',
    excludeTracks: any[] = [],
    segment = 'all'
  ) {
    return this.load().pipe(
      map((data: any) => {
        const day = data.schedule[dayIndex];
        day.shownSessions = 0;

        queryText = queryText.toLowerCase().replace(/,|\.|-/g, ' ');
        const queryWords = queryText.split(' ').filter(w => !!w.trim().length);

        day.groups.forEach((group: any) => {
          group.hide = true;

          group.sessions.forEach((session: any) => {
            // check if this session should show or not
            this.filterSession(session, queryWords, excludeTracks, segment);

            if (!session.hide) {
              // if this session is not hidden then this group should show
              group.hide = false;
              day.shownSessions++;
            }
          });
        });

        return day;
      })
    );
  }

  filterSession(
    session: any,
    queryWords: string[],
    excludeTracks: any[],
    segment: string
  ) {
    let matchesQueryText = false;
    if (queryWords.length) {
      // of any query word is in the session name than it passes the query test
      queryWords.forEach((queryWord: string) => {
        if (session.name.toLowerCase().indexOf(queryWord) > -1) {
          matchesQueryText = true;
        }
      });
    } else {
      // if there are no query words then this session passes the query test
      matchesQueryText = true;
    }

    // if any of the sessions tracks are not in the
    // exclude tracks then this session passes the track test
    let matchesTracks = false;
    session.tracks.forEach((trackName: string) => {
      if (excludeTracks.indexOf(trackName) === -1) {
        matchesTracks = true;
      }
    });

    // if the segment is 'favorites', but session is not a user favorite
    // then this session does not pass the segment test
    let matchesSegment = false;
    if (segment === 'favorites') {
      if (this.user.hasFavorite(session.name)) {
        matchesSegment = true;
      }
    } else {
      matchesSegment = true;
    }

    // all tests must be true if it should not be hidden
    session.hide = !(matchesQueryText && matchesTracks && matchesSegment);
  }
  call(call_type:string,contact){
    return this.handleRequest.post("/api/create_room", {type: call_type,contact_number:contact.number, user_id:this.user.getUsername()})
  }
  roomStatus(room_id){
    return this.handleRequest.post("/api/auth_room", {room_id:room_id, user_id:this.user.getUsername()})
  }
  getContacts() {
    return this.handleRequest.get("/api/contacts")
    // .pipe(
    //   map((data: any) => {
    //     return data.contacts.sort((a: any, b: any) => {
    //       const aName = a.name.split(' ').pop();
    //       const bName = b.name.split(' ').pop();
    //       return aName.localeCompare(bName);
    //     });
    //   })
    // );
  }

  getTracks() {
    return this.load().pipe(
      map((data: any) => {
        return data.tracks.sort();
      })
    );
  }

  getMap() {
    return this.load().pipe(
      map((data: any) => {
        return data.map;
      })
    );
  }
}
